module.exports = __webpack_public_path__ + "assets/Crime-white.0aa6d864.svg";